module.exports = __webpack_public_path__ + "caedf36bc6032e2955bbcbcc93a35210.png";